import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditStudent from '../../components/students/FormAddEditStudent';
const CreateStudent = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditStudent /></WrapperSection>);
export default CreateStudent;
